












































import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'

@Component
export default class Record extends Vue {
  loading = true
  columns = [
    {
      title: 'Device Name',
      dataIndex: 'deviceName',
    },
    {
      title: 'Employee Name',
      dataIndex: 'employeeName',
    },
    {
      title: 'Similarity',
      dataIndex: 'similarity',
    },
    {
      title: 'Entry Time',
      dataIndex: 'time',
      sorter: true,
    },
    {
      title: 'Temperature',
      dataIndex: 'temperature',
    },
    // {
    //   title: 'Image',
    //   dataIndex: 'image',
    //   scopedSlots: { customRender: 'photo' },
    // },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: true,
      scopedSlots: { customRender: 'status' },
    },
  ];
  moment = moment

  get role() {
    return this.$store.state.userStore.role
  }

  get records() {
    return this.$store.state.recordStore.records
  }

  get total() {
    return this.$store.state.recordStore.total
  }

  get pagination() {
    return this.$store.state.recordStore.pagination
  }

  get searchKey() {
    return this.$store.state.recordStore.search
  }

  set searchKey(val) {
    this.$store.commit('updateRecordSearchKey', val)
  }

  get organizationList() {
    return this.$store.state.organizationStore.organizationList
  }

  get organization() {
    return this.$store.state.recordStore.organization
  }

  set organization(val) {
    this.$store.commit('updateCurrentRecordOrg', val)
  }

  mounted() {
    this.$store.dispatch('getRecords', {
      page: this.pagination.current,
      limit: this.pagination.pageSize
    }).then(() => {
      this.loading = false
    })
    .catch(() => {
      this.loading = false
    })
  }

  updateRecords(pagination:any, filters:any, sorter:any) {
    this.loading = true
    this.$store.commit('updateRecordPagination', {current: pagination.current})
    this.$store.commit('updateRecordSorter', {field: sorter.field, order: sorter.order === 'ascend'? 'asc': 'desc'})
    this.$store.dispatch('getRecords').then(() => {
      this.loading = false
    })
  }

  search() {
    this.loading = true
    this.$store.commit('updateRecordPagination', {current: 1})
    this.$store.dispatch('getRecords').then(() => {
      this.loading = false
    })
  }

  openWindow(link: string) {
    const image = new Image()
    image.src = link
    const w = window.open("")
    if (w) {
      w.document.write(image.outerHTML)
      w.document.close()
    }
  }

  onRangeChanged(dates: any[]) {
    this.loading = true
    this.$store.commit('updateRecordRange', dates)
    this.$store.commit('updateRecordPagination', {current: 1})
    this.$store.dispatch('getRecords').then(() => {
      this.loading = false
    })
  }

  downloadRecord(type: string) {
    this.$store.dispatch('downloadRecords', type)
  }
}

